import { AccountSearchOutlineIcon } from './AccountSearchOutlineIcon';

/**
 * author: GreenTurtwig
 * id F6808872-4EB9-43AF-BD74-BDA6861E1862
 * name account-search-outline
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-search-outline.svg
 * tags
 * - Account / User 
 */
export const PersonSearchOutlineIcon = AccountSearchOutlineIcon;
export default PersonSearchOutlineIcon